import { render, staticRenderFns } from "./AutomationDepartmentPermissionRow.vue?vue&type=template&id=65f6c1b3&scoped=true"
import script from "./AutomationDepartmentPermissionRow.vue?vue&type=script&lang=js"
export * from "./AutomationDepartmentPermissionRow.vue?vue&type=script&lang=js"
import style0 from "./AutomationDepartmentPermissionRow.vue?vue&type=style&index=0&id=65f6c1b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f6c1b3",
  null
  
)

export default component.exports